import { getExerciseCategoryWiseWorkoutCompletedReport, getExerciseWiseStrengthAssessmentReport, getStrengthAssessmentReport, getTotalWeightsLiftedReport, getTotalWorkoutReport, getTotalWorkoutsCompletedHourlyWise, getUserGoalCountReport, getWorkoutCompletedReport, getWorkoutSessionsSplitMinutes } from "../../services/report.service";
import { types } from "./types";

export const getTotalWorkoutReportAction = (days) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await getTotalWorkoutReport(days);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.TOTAL_WORKOUT_REPORT, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.TOTAL_WORKOUT_REPORT,
      payload: { error: response.error },
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};

export const getStrengthAssessmentReportAction = (days) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await getStrengthAssessmentReport(days);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.STRENGTH_ASSESSMENT_REPORT, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.STRENGTH_ASSESSMENT_REPORT,
      payload: { error: response.error },
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};


export const getUserGoalCountReportAction = (days) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await getUserGoalCountReport(days);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.USER_GOAL_COUNT_REPORT, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.USER_GOAL_COUNT_REPORT,
      payload: { error: response.error },
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};


export const getWorkoutCompletedReportAction = (days) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await getWorkoutCompletedReport(days);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.WORKOUT_COMPLETED_REPORT, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.WORKOUT_COMPLETED_REPORT,
      payload: { error: response.error },
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};


export const getExerciseWiseStrengthAssessmentReportAction = (days) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await getExerciseWiseStrengthAssessmentReport(days);
  if (response?.status) {
    const result = response?.data?.response;
    dispatch({ type: types.EXERCISE_WISE_STRENGH_ASSESSMENT_REPORT, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.EXERCISE_WISE_STRENGH_ASSESSMENT_REPORT,
      payload: { error: response.error },
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};


export const exerciseCategoryWiseWorkoutCompletedReportAction = (days) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await getExerciseCategoryWiseWorkoutCompletedReport(days);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.EXERCISE_CATEGORY_WISE_WORKOUT_COMPLETED_REPORT, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.EXERCISE_CATEGORY_WISE_WORKOUT_COMPLETED_REPORT,
      payload: { error: response.error },
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};


export const getTotalWeightsLiftedReportAction = (days) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await getTotalWeightsLiftedReport(days);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.TOTAL_WEIGHTS_LIFTED_REPORT, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.TOTAL_WEIGHTS_LIFTED_REPORT,
      payload: { error: response.error },
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};


export const getWorkoutSessionSplitMinutesReportAction = (days) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
  const response = await getWorkoutSessionsSplitMinutes(days);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.WORKOUT_SESSION_SPLIT_MINUTES, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.WORKOUT_SESSION_SPLIT_MINUTES,
      payload: { error: response.error },
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};


export const getExerciseWiseStrengthAssessMentReportAction = (days) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
//   const response = await getWorkoutSessionsSplitMinutes(days);
    const response = await getExerciseWiseStrengthAssessmentReport(days);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.EXERCISE_WISE_STRENGH_ASSESSMENT_REPORT, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.EXERCISE_WISE_STRENGH_ASSESSMENT_REPORT,
      payload: { error: response.error },
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};


export const getTotalWorkoutsCompletedHourlyAction = (days) => async (dispatch) => {
  dispatch({ type: types.LOADER_VISIBLE });
//   const response = await getWorkoutSessionsSplitMinutes(days);
    const response = await getTotalWorkoutsCompletedHourlyWise(days);
  if (response?.status) {
    const result = response?.data?.data;
    dispatch({ type: types.TOTAL_WORKOUTS_COMPLETED_HOURLY_WISE, payload: result });
    dispatch({ type: types.LOADER_HIDE });
    return { data: result };
  } else {
    dispatch({
      type: types.TOTAL_WORKOUTS_COMPLETED_HOURLY_WISE,
      payload: { error: response.error },
    });
    dispatch({ type: types.LOADER_HIDE });
    return { error: response.error };
  }
};
